export enum HiLoComponentType {
	NumberSpinner = "NumberSpinner",
	GridContainer = "GridContainer"
}
